export function getUniqueKey() {
    let uniqueKey = '';
    while (uniqueKey.length < 10) {
        const randomDigit = Math.floor(Math.random() * 10);
        uniqueKey = uniqueKey + randomDigit;
    }
    return uniqueKey;
}
  